// extracted by mini-css-extract-plugin
export var deleteIcon = "_ta-5";
export var deleteOption = "_ta-3";
export var divider = "_ta-2";
export var downloadIcon = "_ta-4";
export var drawer = "_ta-0";
export var drawerFooter = "_ta-6";
export var drawerOpen = "_ta-1";
export var highlighted = "_ta-7";
export var lighterHighlight = "_ta-8";